export default __webpack_public_path__ + "static/industries-bg-b75b2ffdadf9c282550eceaad42aa379.jpg";